import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  AlertModule,
  ButtonsModule,
  CardModule,
  CheckboxModule,
  DropdownModule,
  IconModule,
  InputModule,
  ModalModule,
  RadioButtonModule,
  TooltipModule,
} from 'axis-components';
import { MediaModule } from 'axis-components/media';
import { RequestService } from '../../../_services/request/request.service';
import { SelectionCoveragesService } from '../../../_services/uim-ui/selection-coverages.service';
import { HeaderSharedService } from '../../../_services/header-shared.service';
import { ModalUimuiReviewStatePdfComponent } from '../../../_shared/modal-uimui-review-state-pdf/modal-uimui-review-state-pdf.component';
import { TooltipLabelComponent } from '../../../_shared/tooltip/tooltip-label.component';
import {
  FormType,
  RequestProgressStep,
  UserRole,
} from '../../../config/constants';
import { UimuiBaseRulesService } from '../../../state-disclosures/uimui/services/uimui-base-rules.service';
import { NotificationService } from '../../../_services/notification/notification.service';

@Component({
  selector: 'app-uimui-selection-coverages',
  templateUrl: './uimui-selection-coverages.component.html',
  standalone: true,
  imports: [
    AlertModule,
    ButtonsModule,
    CardModule,
    CommonModule,
    CheckboxModule,
    DropdownModule,
    IconModule,
    InputModule,
    MediaModule,
    ModalModule,
    RadioButtonModule,
    TooltipModule,
    ReactiveFormsModule,
    ModalUimuiReviewStatePdfComponent,
    TooltipLabelComponent,
  ],
})
export class UimuiSelectionCoveragesComponent {
  private static readonly POLICY_LIABILITY_LIMITS = 'PolicyLiabilityLimits';
  private static readonly DEFAULT_POLICY_LIMIT_TYPE = 'CombinedSingleLimit';
  @ViewChild('modalStateReview')
  modalStateReview!: ModalUimuiReviewStatePdfComponent;
  public unSelectionCoverage: FormGroup;
  notReadAlert = true;
  accountDetails: any = null;
  constructor(
    private readonly selectionCoveragesService: SelectionCoveragesService,
    private router: Router,
    private fb: FormBuilder,
    private baseRulesService: UimuiBaseRulesService,
    private requestService: RequestService,
    private notificationService: NotificationService,
    private readonly headerSharedService: HeaderSharedService,
  ) {}

  data: any;
  garageStatesData: any;
  selectedOption = '';
  selectedGroup = '';
  selectedGroupData: { [key: string]: string } = {};
  @Output() optionSelected = new EventEmitter<string>();
  @Output() groupSelected = new EventEmitter<string>();
  @Output() groupDataSelected = new EventEmitter<{ [key: string]: string }>();

  // Events emitted to playground component for workflow control
  @Output() continueClickedPlayground = new EventEmitter<void>();
  @Output() backClickedPlayground = new EventEmitter<void>();
  @Output() dataChangedPlayground = new EventEmitter<void>();

  public stateList = [
    { name: 'Alabama', id: 'AL' },
    { name: 'Alaska', id: 'AK' },
    { name: 'Arizona', id: 'AZ' },
    { name: 'Arkansas', id: 'AR' },
    { name: 'California', id: 'CA' },
    { name: 'Colorado', id: 'CO' },
    { name: 'Connecticut', id: 'CT' },
    { name: 'Delaware', id: 'DE' },
    { name: 'Florida', id: 'FL' },
    { name: 'Georgia', id: 'GA' },
    { name: 'Hawaii', id: 'HI' },
    { name: 'Idaho', id: 'ID' },
    { name: 'Illinois', id: 'IL' },
    { name: 'Indiana', id: 'IN' },
    { name: 'Iowa', id: 'IA' },
    { name: 'Kansas', id: 'KS' },
    { name: 'Kentucky', id: 'KY' },
    { name: 'Louisiana', id: 'LA' },
    { name: 'Maine', id: 'ME' },
    { name: 'Maryland', id: 'MD' },
    { name: 'Massachusetts', id: 'MA' },
    { name: 'Michigan', id: 'MI' },
    { name: 'Minnesota', id: 'MN' },
    { name: 'Mississippi', id: 'MS' },
    { name: 'Missouri', id: 'MO' },
    { name: 'Montana', id: 'MT' },
    { name: 'Nebraska', id: 'NE' },
    { name: 'Nevada', id: 'NV' },
    { name: 'New Hampshire', id: 'NH' },
    { name: 'New Jersey', id: 'NJ' },
    { name: 'New Mexico', id: 'NM' },
    { name: 'New York', id: 'NY' },
    { name: 'North Carolina', id: 'NC' },
    { name: 'North Dakota', id: 'ND' },
    { name: 'Ohio', id: 'OH' },
    { name: 'Oklahoma', id: 'OK' },
    { name: 'Oregon', id: 'OR' },
    { name: 'Pennsylvania', id: 'PA' },
    { name: 'Rhode Island', id: 'RI' },
    { name: 'South Carolina', id: 'SC' },
    { name: 'South Dakota', id: 'SD' },
    { name: 'Tennessee', id: 'TN' },
    { name: 'Texas', id: 'TX' },
    { name: 'Utah', id: 'UT' },
    { name: 'Vermont', id: 'VT' },
    { name: 'Virginia', id: 'VA' },
    { name: 'Washington', id: 'WA' },
    { name: 'West Virginia', id: 'WV' },
    { name: 'Wisconsin', id: 'WI' },
    { name: 'Wyoming', id: 'WY' },
  ];
  dropdownErrorBlurred = true;

  private bodilyInjuryOptions: { value: string; label: string }[] = [];
  private propertyDamageOptions: { value: string; label: string }[] = [];
  firstTimeView = true;
  private userMadeChanges = false;
  private isInitializing = true;
  private checkAndResetOutstandingData(): void {
    if (!this.userMadeChanges || this.isInitializing) {
      return;
    }

    // Generate current data from form (same logic as setDataDump)
    let currentFormData = {};
    for (const [key, value] of Object.entries(this.unSelectionCoverage.value)) {
      // Null-safe object mapping prevents base-rules helper from crashing.
      currentFormData[key] =
        typeof value === 'object' && value !== null
          ? this.baseRulesService.getValueOfFormControls(value)
          : value;
    }

    const storedFormData = this.baseRulesService.dataDump?.['data'] || {};

    // Compare and retain selections if data unchanged
    if (JSON.stringify(currentFormData) !== JSON.stringify(storedFormData)) {
      if (this.baseRulesService.dataDump) {
        this.baseRulesService.dataDump['outstandingStates'] = [];
        this.baseRulesService.savedBaseRules = {};
        // Clear summary confirmation when prior selections change
        delete this.baseRulesService.dataDump['summaryConfirmation'];
      }
      this.userMadeChanges = false;

      // Notify playground component when data changes (resets subsequent steps)
      if (this.baseRulesService.isPlayground) {
        this.dataChangedPlayground.emit();
      }
    }
  }
  get hasGarageStates(): boolean {
    return this.requestService.hasGarageStates();
  }
  mapToFormValue(
    controlName: string,
    value: string,
  ): {
    name: string;
    value: string;
    selectedIndex: number;
  } {
    // Determine the appropriate name and selectedIndex based on controlName
    let name: string;
    let selectedIndex: number;
    let options: { value: string; label: string }[];

    if (controlName === 'bodilyInjurySelection') {
      name = 'bodilyInjury';
      options = this.bodilyInjuryOptions;
      selectedIndex = this.bodilyInjuryOptions.findIndex(
        (option) => option.value === value,
      );
    } else if (controlName === 'propertyDamageSelection') {
      name = 'propertyDamage';
      options = this.propertyDamageOptions;
      selectedIndex = this.propertyDamageOptions.findIndex(
        (option) => option.value === value,
      );
    } else if (controlName === 'garagingSelection') {
      name = 'garaging';
      options = this.garageStatesData?.garagingOptions || [];
      selectedIndex = options.findIndex(
        (option: any) => option.value === value,
      );
    } else if (
      this.data?.groups.some((group: any) => group.name === controlName)
    ) {
      name = controlName;
      const group = this.data.groups.find(
        (group: any) => group.name === controlName,
      );
      options = group.options;
      selectedIndex = options.findIndex(
        (option: any) => option.value === value,
      );
    } else {
      name = controlName; // Fallback name
      selectedIndex = 0; // Default index if no options match
    }
    return {
      name,
      value,
      selectedIndex: selectedIndex >= 0 ? selectedIndex : 0,
    };
  }

  ngOnInit(): void {
    this.getAccountDetails();
    // Helper to map datadumpvalues to formgroup
    const unselectedValues: { [key: string]: any } = {};
    if ('data' in this.baseRulesService.dataDump) {
      const data = this.baseRulesService.dataDump['data'];
      Object.keys(data).forEach((key) => {
        if (key) {
          unselectedValues[key] = data[key];
        }
      });
      if (unselectedValues['undoConfirmStateDis'] === true) {
        this.notReadAlert = false;
      }
    }
    this.unSelectionCoverage = this.fb.group({
      unSelectInsuredName: [
        this.accountDetails.insuredName ||
          unselectedValues['unSelectInsuredName'] ||
          '',
        // Validators.required,
      ],
      unSelectInsuredAuthName: [
        this.accountDetails.title ||
          unselectedValues['unSelectInsuredAuthName'] ||
          '',
        // Validators.required,
      ],
      unSelectInsuredPolicy: [
        this.accountDetails.insuredCompanyName ||
          unselectedValues['unSelectInsuredPolicy'] ||
          '',
        // Validators.required,
      ],
      unSelectBusinessMail: [
        this.accountDetails.insuredEmail ||
          unselectedValues['unSelectBusinessMail'] ||
          '',
        [
          // Validators.required,
          // Validators.pattern(
          //   '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z0-9.\\-]{2,63}$',
          // ),
        ],
      ],
      unSelectBusinessNum: [
        this.accountDetails.phoneNumber ||
          unselectedValues['unSelectBusinessNum'] ||
          '',
        [Validators.pattern('^[0-9]{10}$')],
      ],

      unSelectBusinessAdd: [
        this.accountDetails.address ||
          unselectedValues['unSelectBusinessAdd'] ||
          '',
        // Validators.required,
      ],
      unSelectBusinessCity: [
        this.accountDetails.city ||
          unselectedValues['unSelectBusinessCity'] ||
          '',
        // Validators.required,
      ],
      unSelectBusinessState: [
        this.accountDetails.state ||
          unselectedValues['unSelectBusinessState'] ||
          '',
        // Validators.required,
      ],
      bodilyInjurySelection: [
        this.mapToFormValue(
          'bodilyInjurySelection',
          unselectedValues['bodilyInjurySelection'],
        ) || '',
        Validators.required,
      ],
      propertyDamageSelection: [
        this.mapToFormValue(
          'propertyDamageSelection',
          unselectedValues['propertyDamageSelection'],
        ) || '',
        Validators.required,
      ],
      undoConfirmStateDis: [
        unselectedValues['undoConfirmStateDis'],
        Validators.required,
      ],
      garagingSelection: [
        this.mapToFormValue(
          'garagingSelection',
          unselectedValues['garagingSelection'],
        ) || '',
        this.hasGarageStates ? Validators.required : null,
      ],
    });
    //Load Selection Coverage Data
    this.selectionCoveragesService.getSelectionData().subscribe((data) => {
      this.data = data;
      for (const group of this.data.groups) {
        this.unSelectionCoverage.addControl(
          group.name,
          this.fb.control(
            this.mapToFormValue(group.name, unselectedValues[group.name]),
            Validators.required,
          ),
        );
      }
      // Capture the initial form value after all controls are added
      const initialFormValue = this.unSelectionCoverage.getRawValue();
      this.unSelectionCoverage.valueChanges.subscribe(() => {
        const currentFormValue = this.unSelectionCoverage.getRawValue();

        const hasChanged = Object.keys(currentFormValue).some((key) => {
          // For objects (like dropdowns/radios), compare their .value property
          const initial = initialFormValue[key];
          const current = currentFormValue[key];
          if (initial && typeof initial === 'object' && 'value' in initial) {
            return initial.value !== (current?.value ?? current);
          }
          return initial !== current;
        });
        // Check if any control is valid and has been interacted with
        const anyValid = Object.values(this.unSelectionCoverage.controls).some(
          (control: any) => control.valid,
        );
        if (
          !this.notificationService.UMUIMSelectionCoverageNotificationFlag &&
          this.requestService.getUserRole() === UserRole.BROKER &&
          hasChanged &&
          anyValid
        ) {
          this.notificationService.UMUIMSelectionCoverageNotificationFlag = true;
          this.notificationService.showNotification(
            'Please note that the insured must fill out this form using the link sent to their inbox. All changes made to this view will not be saved.',
            'warning',
            'Selections Will Not Be Saved',
          );
        }
        if (!this.isInitializing) {
          this.userMadeChanges = true;
        }

        // Reset subsequent steps whenever form values change (AC2)
        if (hasChanged) {
          this.headerSharedService.resetSteps('uimui');
        }

        // Check and reset outstanding data when form values change
        if (this.baseRulesService.isPlayground) {
          this.checkAndResetOutstandingData();
        }
      });

      // Update propertyDamageOptions after data is loaded
      this.bodilyInjuryOptions = this.data.bodilyInjuryOptions || [];
      this.propertyDamageOptions = this.data.propertyDamageOptions || [];
    });
    // Load garage states data
    this.selectionCoveragesService
      .getGarageStatesData()
      .subscribe((garageData) => {
        this.garageStatesData = garageData;
      });
    this.goTop();

    // Mark initialization as complete after form setup
    setTimeout(() => {
      this.isInitializing = false;
    }, 0);

    // Subscribe to value changes for all relevant controls
    this.unSelectionCoverage
      .get('bodilyInjurySelection')
      .valueChanges.subscribe((value) => {
        this.selectedOption = value;
        this.optionSelected.emit(value);
        if (this.isPolicyLiabilityLimitsSelected) {
          // Hide-path behavior: clear limits controls and remove required validation.
          this.clearTypeOfLimitsSelections();
        } else {
          // Show-path behavior: restore required validation for limits controls.
          this.enableTypeOfLimitsValidation();
        }
      });

    this.unSelectionCoverage
      .get('propertyDamageSelection')
      .valueChanges.subscribe((value) => {
        this.selectedGroup = value;
        this.groupSelected.emit(value);
      });

    this.unSelectionCoverage
      .get('unSelectBusinessNum')
      ?.valueChanges.subscribe((value) => {
        const control = this.unSelectionCoverage.get('unSelectBusinessNum');
        if (value && control) {
          control.setValidators([
            Validators.pattern('^[0-9]{10}$|^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
          ]);
          if (this.requestService.request?.requestDetails?.accountDetail) {
            this.requestService.request.requestDetails.accountDetail.phoneNumber =
              value;
          }
        } else if (control) {
          // Clear validators when the field is empty
          control.clearValidators();
          if (this.requestService.request?.requestDetails?.accountDetail) {
            this.requestService.request.requestDetails.accountDetail.phoneNumber =
              '';
          }
        }
        control?.updateValueAndValidity({ emitEvent: false });
      });
  }
  getAccountDetails(): void {
    if (
      this.requestService.request &&
      this.requestService.request.requestDetails &&
      this.requestService.request.requestDetails.accountDetail
    ) {
      this.accountDetails =
        this.requestService.request.requestDetails.accountDetail;
    }
  }

  checkPreselect(option: any): boolean {
    const formValues = this.unSelectionCoverage?.value || {};
    return (
      option?.value === formValues.bodilyInjurySelection?.value ||
      option?.value === formValues.propertyDamageSelection?.value ||
      option?.value === formValues.garagingSelection?.value
    );
  }

  patchValue(controlName: string, value: string): void {
    const formValue = this.mapToFormValue(controlName, value);
    this.unSelectionCoverage.patchValue({ [controlName]: formValue });
  }

  get isPolicyLiabilityLimitsSelected(): boolean {
    // True when the new Policy Liability Limits radio option is selected.
    return (
      this.unSelectionCoverage?.get('bodilyInjurySelection')?.value?.value ===
      UimuiSelectionCoveragesComponent.POLICY_LIABILITY_LIMITS
    );
  }

  private clearTypeOfLimitsSelections(): void {
    // Clear and de-validate hidden Type of Limits controls.
    if (!this.data?.groups?.length) {
      return;
    }

    this.data.groups.forEach((group: any) => {
      const control = this.unSelectionCoverage.get(group.name);
      if (control) {
        control.clearValidators();
        control.reset();
        control.markAsUntouched();
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  private enableTypeOfLimitsValidation(): void {
    // Re-enable required validation when Type of Limits is visible again.
    if (!this.data?.groups?.length) {
      return;
    }

    this.data.groups.forEach((group: any) => {
      const control = this.unSelectionCoverage.get(group.name);
      if (control) {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  goTop(): void {
    window.scrollTo(0, 0);
  }

  onModalContiueClose(result: boolean) {
    this.notReadAlert = !result;
    if (result) {
      this.unSelectionCoverage.patchValue({
        undoConfirmStateDis: true,
      });
    }
  }

  onBack(): void {
    if (this.baseRulesService.isPlayground) {
      this.backClickedPlayground.emit();
      return;
    }
    this.router.navigate(['/insured/uimui-consent'], {
      queryParamsHandling: 'preserve',
    });
  }
  updateRequestDetailsWithFormData() {
    const stateValue = this.unSelectionCoverage.value.unSelectBusinessState;
    const stateCode =
      typeof stateValue === 'object' && stateValue !== null
        ? stateValue.id // Extract the state code if it's an object
        : stateValue;
    // Find the matching state object in stateList using the state code
    const stateObject = this.stateList.find((state) => state.id === stateCode);
    const stateName = stateObject ? stateObject.name : stateCode;
    this.requestService.phoneNumber =
      this.unSelectionCoverage.value.unSelectBusinessNum || '';
    // Get account detail values from the form
    const accountDetails = {
      accountDetail: {
        insuredName: this.unSelectionCoverage.value.unSelectInsuredName,
        title: this.unSelectionCoverage.value.unSelectInsuredAuthName,
        name: this.unSelectionCoverage.value.unSelectInsuredPolicy,
        insuredEmail: this.unSelectionCoverage.value.unSelectBusinessMail,
        phoneNumber: this.unSelectionCoverage.value.unSelectBusinessNum,
        address: this.unSelectionCoverage.value.unSelectBusinessAdd,
        city: this.unSelectionCoverage.value.unSelectBusinessCity,
        state: stateName,
      },
    };
    // Update request details with new account values
    this.requestService.updateRequestDetails(accountDetails);
  }

  onContinue(): void {
    this.firstTimeView = false;
    this.checkAndResetOutstandingData();
    // Skip validation for phone number
    const phoneControl = this.unSelectionCoverage.get('unSelectBusinessNum');
    if (phoneControl) {
      phoneControl.clearValidators();
      phoneControl.updateValueAndValidity();
    }
    // Mark all controls as touched to trigger validation
    Object.keys(this.unSelectionCoverage.controls).forEach((key) => {
      this.unSelectionCoverage.get(key)?.markAsTouched();
    });
    const fieldsToValidate = [
      'bodilyInjurySelection',
      'propertyDamageSelection',
    ];
    if (this.hasGarageStates) {
      fieldsToValidate.push('garagingSelection');
    }

    if (this.data?.groups && !this.isPolicyLiabilityLimitsSelected) {
      this.data.groups.forEach((group: any) => {
        fieldsToValidate.push(group.name);
      });
    }
    // Validate each field
    fieldsToValidate.forEach((field) => {
      const control = this.unSelectionCoverage.get(field);
      if (control) {
        const selectedValue = control.value?.value;
        if (!selectedValue) {
          control.setErrors({ required: true });
        }
      }
    });
    if (this.unSelectionCoverage.invalid) {
      window.scrollTo(0, 0);
      return;
    }
    this.updateRequestDetailsWithFormData();
    this.setCoverageSelection();
    this.setDataDump();
    if (this.notReadAlert) {
      window.scrollTo(0, 0);
      return;
    }

    if (this.baseRulesService.isPlayground) {
      // In playground mode, emit event instead of navigating
      this.continueClickedPlayground.emit();
      return;
    }

    this.requestService.refreshRequestData(false).subscribe({
      next: () => {
        this.handleContinueWithFreshStep();
      },
      error: () => {
        this.handleContinueWithFreshStep();
      },
    });
  }

  private handleContinueWithFreshStep(): void {
    // Read current DB-backed step snapshot before moving the form ahead.
    const isUimuiCompleted = this.requestService.isFormTypeAlreadyCompleted(
      FormType.UM_UIM,
    );

    // If UM/UIM is already completed, do not continue with consent routing.
    if (isUimuiCompleted) {
      return;
    }
    this.requestService.updateRequestProgress(
      FormType.UM_UIM,
      RequestProgressStep.SELECTION_OF_COVERAGES,
      this.baseRulesService.dataDump,
    );
    this.router.navigate(['/insured/uimui-review-state'], {
      queryParamsHandling: 'preserve',
    });
  }

  setDataDump() {
    let formData = {};
    for (const [key, value] of Object.entries(this.unSelectionCoverage.value)) {
      formData[key] =
        typeof value === 'object' && value !== null
          ? this.baseRulesService.getValueOfFormControls(value)
          : value;
    }
    formData = { data: formData };
    this.baseRulesService.dataDump = {
      ...this.baseRulesService.dataDump,
      ...formData,
    };
  }
  setCoverageSelection() {
    this.baseRulesService.selectionTypeKey = this.unSelectionCoverage.get(
      'bodilyInjurySelection',
    ).value.value;
    this.baseRulesService.coverageTypeKey = this.unSelectionCoverage.get(
      'propertyDamageSelection',
    ).value.value;

    // Keep downstream query construction stable when Type of Limits is hidden.
    if (this.isPolicyLiabilityLimitsSelected) {
      this.baseRulesService.limitTypeKey =
        UimuiSelectionCoveragesComponent.DEFAULT_POLICY_LIMIT_TYPE;
    }

    const selectedLimitType = this.unSelectionCoverage.get(
      this.data?.groups[0].name,
    ).value?.value;
    if (selectedLimitType) {
      this.baseRulesService.limitTypeKey = selectedLimitType;
    }
    if (this.hasGarageStates) {
      this.baseRulesService.garagingSelectionKey =
        this.unSelectionCoverage.get('garagingSelection').value.value;
    }
  }
}
